import './styles.scss';

const PictureComponent = ({ srcBig, srcSmall = '', alt = '', className = '' }) => (
    <picture className={`picture-component ${className}`}>
        {srcSmall && <source srcSet={srcSmall} media="(max-width: 1024px)" />}
        <img src={srcBig} alt={alt} />
    </picture>
);

export default PictureComponent;
